document.addEventListener("DOMContentLoaded", () => {

	const productForm = document.querySelector('.product-form');
	const productFormOffsetTop = productForm.offsetTop + 300;

	// Function to handle the scroll event
	function handleScroll() {
		if (window.pageYOffset > productFormOffsetTop) {
			document.body.classList.add('sticky--atc');
		} else {
			// Remove the sticky class when at the top
			document.body.classList.remove('sticky--atc');
		}
	}

	// Add the scroll event listener
	window.addEventListener('scroll', handleScroll);
  
});

document.addEventListener("DOMContentLoaded", function () {
  const productContainer = document.querySelector(".mobile-sticky-form");
  if (!productContainer) return;

  const variantSelect = productContainer.querySelector('select[name="id"]');
  const mainVariantInput = productContainer.querySelector('input[name="id"]');

  if (variantSelect && mainVariantInput) {
    variantSelect.addEventListener("change", function () {
      mainVariantInput.value = this.value;
    });
  }
});
